import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { MULTIFACILITY_PHASE2, MULTIFACILITY_DEFERRED_ADMISSION } from '../reusableclassesAndFunctions/constants';
import {
  ReferralAction, actionStateLabel, facilityStateLine, facilityAlreadyIn, facilityAlreadyHint,
  facilitiesAlreadyIn, facilitiesAlreadyText, rowStateLabel,
  ResidentOfficeOption, residentOfficeOptions, facilitiesWithoutResidentOffice
} from '../referralDialog/facility-state';

@Component({
  selector: 'app-addemailForAcceptReferral',
  templateUrl: './addemailForAcceptReferral.component.html',
  styleUrls: ['./addemailForAcceptReferral.component.scss']
})

export class AddemailForAcceptReferralComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;  
  showAddButton = false;
  addUpdateParticipantList: any = [] = []; 
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  textButton:string="Accept";
  message:string="";
  personName:string="";
  textForPerson:string="";

  // Rollout flags — provider picker (phase 2, ON) and the deferred
  // "Create resident now" checkbox (OFF until the client asks for it).
  mfPhase2 = MULTIFACILITY_PHASE2;
  mfDeferred = MULTIFACILITY_DEFERRED_ADMISSION;

  // Multi-recipient referrals (portal "Update Responses" pattern): the Accept
  // is sent to the SELECTED recipient facilities only. Shown when the referral
  // was shared with 2+ facilities.
  providerOptions: any[] = [];
  selectedProviderKeys: { [key: string]: boolean } = {};
  // Decoupled admission: CHECKED (default) = today's flow (resident form next);
  // unchecked = accept only — the resident can be created later from the
  // Accepted tab under the right facility.
  // Set by the footer button that was clicked: "Accept" = no resident now,
  // "Accept & Create Resident" = open the resident form after the accept (2026-09-28).
  createResidentNow = false;

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddemailForAcceptReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach((oe:any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    if(this.data){
     this.showAddButton = true;    
    }   
    this.personName=this.data.selectedRecord.name;
    //this.textForPerson = `We are pleased to inform you that ${this.personName} has been officially accepted.`;
    this.textForPerson = `We are pleased to inform you that <b>${this.personName}</b> has been officially <b>accepted</b>.`;

    // Provider picker only when the referral reached 2+ recipient facilities.
    // NOTHING is pre-selected (client req) — the user must consciously choose
    // which facility the response applies to; the only exception is a per-site
    // action from the Recipients panel, which checks exactly that site.
    // Phase gating: picker is phase-2 everywhere — even per-site actions from
    // the Recipients panel open this classic popup until MULTIFACILITY_PHASE2.
    const fac = this.data.selectedRecord?.sharedFacilities || [];
    if (this.mfPhase2 && this.data.selectedRecord?.isExternal && fac.length > 1) {
      this.providerOptions = fac;
      if (this.data.preselectProviderKey) {
        this.selectedProviderKeys[this.data.preselectProviderKey] = true;
      }
      this.syncResidentOffice();   // default resident office for a preselected facility
    }

    if (this.data.selectedRecord.emails) {
      let emailList = this.data.selectedRecord.emails.split(',');
      emailList.forEach((email: string) => {
        email = email.trim();
        if (email !== "") {
          let toArray = email.split("@");
          let shortName = toArray[0].match(/\b(\w)/g)?.join('') || '';
          var obj = {
            name: "",
            email: email,
            img: "",
            shortName: shortName
          };
          this.addUpdateParticipantList.push(obj);
        }
      });

      // Reset input
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton = "Accept & Send Mail";
      } else {
        this.showAddButton = true;
      }
    }
 
  }


  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
      this.textButton="Accept & Send Mail";
    } else {
      this.showAddButton = true;
       this.textButton="Accept";
    }
  }


  //==== For Add Email================//

  addEmail() {
    var check = [];
    check = this.addUpdateParticipantList.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase())

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        email: this.emailAssigned,
        img: "",
        shortName: shortName
      }
      this.addUpdateParticipantList.push(obj);
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton="Accept & Send Mail";
      } else {
        this.showAddButton = true;
        this.textButton="Accept";
      }
    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

  // ── Provider picker helpers ──
  provKey(f: any): string { return (f.providerAdmissionRequestId || '') + '|' + (f.facilityName || ''); }
  // Sibling facilities need the portal's providerAdmissionRequestId to be
  // targeted — payloads synced before v8 lack it (resync fills it in).
  // Facility access rule (canAct is computed by the list): facilities whose office
  // the user cannot enter are shown but cannot be selected.
  // Facility state (2026-09-25): every facility shows its CURRENT state (who · when);
  // a facility that is ALREADY Accepted cannot be selected — the hospital already
  // has that answer, so re-sending it is blocked with a message instead.
  readonly action: ReferralAction = 'accept';
  actionLabel(): string { return actionStateLabel(this.action); }
  stateLine(f: any): string { return facilityStateLine(f); }
  alreadyIn(f: any): boolean { return facilityAlreadyIn(f, this.action); }
  alreadyList(): any[] { return facilitiesAlreadyIn(this.providerOptions, this.action); }
  alreadyText(): string { return facilitiesAlreadyText(this.providerOptions, this.action); }
  allAlready(): boolean { return this.providerOptions.length > 0 && this.alreadyList().length === this.providerOptions.length; }
  rowState(): string { return rowStateLabel(this.data?.selectedRecord); }

  providerDisabled(f: any): boolean {
    return f?.canAct === false || this.alreadyIn(f) || (!f.isMine && !f.providerAdmissionRequestId);
  }
  providerHint(f: any): string {
    if (f?.canAct === false) return 'You do not have access to this facility\'s office';
    if (this.alreadyIn(f)) return facilityAlreadyHint(f, this.action);
    return this.providerDisabled(f) ? 'Sync this referral again to enable responding for this facility' : '';
  }
  selectedProviders(): any[] {
    return this.providerOptions.filter((f: any) => this.selectedProviderKeys[this.provKey(f)]);
  }
  canSubmitProviders(): boolean {
    return !this.providerOptions.length || (this.selectedProviders().length > 0 && !this.allAlready());
  }
  // Is THIS office among the selected recipients? Single-recipient referrals
  // are always "own". When only OTHER facilities are selected the Accept is
  // sent on their behalf and no resident is created in this office.
  ownSelected(): boolean {
    return !this.providerOptions.length || this.selectedProviders().some((f: any) => !!f.isMine);
  }
  onBehalfOfOthersOnly(): boolean {
    return this.providerOptions.length > 0 && this.selectedProviders().length > 0 && !this.ownSelected();
  }

  // ── Resident office (2026-09-25): the user picks WHICH office the resident is
  // created in — one of the selected facilities' mapped offices they can work in.
  // Covers accepting for another facility too (the resident goes to ITS office).
  residentOfficeID = 0;
  residentOffices(): ResidentOfficeOption[] { return residentOfficeOptions(this.selectedProviders(), Number(this.myOfficeID)); }
  residentOfficesMissing(): any[] { return facilitiesWithoutResidentOffice(this.selectedProviders(), Number(this.myOfficeID)); }
  onProviderToggle(f: any, checked: boolean) {
    this.selectedProviderKeys[this.provKey(f)] = checked;
    this.syncResidentOffice();
  }
  private syncResidentOffice() {
    const opts = this.residentOffices();
    if (!opts.some(o => o.officeID === this.residentOfficeID)) this.residentOfficeID = opts.length ? opts[0].officeID : 0;
  }
  residentOfficeName(): string {
    const o = this.residentOffices().find(x => x.officeID === this.residentOfficeID);
    return o ? o.officeName : '';
  }
  residentFacilityName(): string {
    const o = this.residentOffices().find(x => x.officeID === this.residentOfficeID);
    return o ? o.facilityName : '';
  }
  // A resident can be created now: nothing linked yet and (single recipient, or a
  // selected facility whose office the user can work in).
  canCreateResident(): boolean {
    if (!this.mfDeferred || this.data?.selectedRecord?.coreID) return false;
    return !this.providerOptions.length || this.residentOffices().length > 0;
  }

  acceptAndSendMail(withResident: boolean = false) {
    this.createResidentNow = !!withResident;
    if (this.allAlready()) {
      this.toastr.warning('Every facility on this referral is already Accepted — nothing new to send.', '', { timeOut: 3500 });
      return;
    }
    // Portal pattern: no action until at least one recipient is selected.
    if (!this.canSubmitProviders()) {
      this.toastr.warning('Select at least one facility this Accept applies to.', '', { timeOut: 3000 });
      return;
    }
    var obj={
      list:this.addUpdateParticipantList,
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      // Plain typed text only — this is what the hospital portal receives
      // (message above is the HTML EMAIL body and must never go there).
      portalMessage: this.message?.trim() || '',
      // Multi-recipient: the selected providers; null = single-recipient flow.
      targetProviders: this.providerOptions.length
        ? this.selectedProviders().map((f: any) => ({
            providerAdmissionRequestId: '' + (f.providerAdmissionRequestId || ''),
            providerId: '' + (f.providerId || ''),
            facilityName: f.facilityName || '',
            isMine: !!f.isMine
          }))
        : null,
      // Decoupled admission: false = skip the resident form, accept with no core.
      // With the deferred flag ON the user decides (and picks the office below);
      // OFF = classic flow: an own-office Accept always opens the resident form,
      // an accept only for other facilities never creates one here.
      createResidentNow: this.mfDeferred ? (this.createResidentNow && this.canCreateResident()) : this.ownSelected(),
      // Office the resident is created in (0 = this office / classic mapping).
      // The list decides: when it is NOT this office, the resident is created
      // under that office and attached to that facility after the accept.
      residentOfficeID: this.mfDeferred && this.createResidentNow && this.providerOptions.length ? this.residentOfficeID : 0,
    }
    this.dialogRef.close(obj);
    //this.dialogRef.close('Added');
    return;
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
     x.email?.trim()).filter(email => !!email) || [];

    var ReqModel={
      referralD: Number(this.data.selectedRecord.referralID),
      coreID:0,
      message: this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)     
    }  
   //return;
    this.spinner=true;    
    this.loaderService.show();
   this.settingsService.acceptReferralQueue(ReqModel).subscribe(response => {
   if (response != undefined) {
      this.responseHolder = response;    
      if (this.responseHolder.status == this.statusConst.statusSuccess) {   
        this.spinner=false; 
        this.loaderService.hide();        
        this.dialogRef.close('Added');
        this.toastr.success('Selected referral accept successfully.', '', {
         timeOut: 3000,
        });
       }else{      
        this.spinner=false; 
        this.loaderService.hide();
       }
     }else{     
      this.spinner=false; 
      this.loaderService.hide(); 
     }
   });
  }

  close() {
    // var obj={
    //   list:[],
    //   message:""
    // }
    // this.dialogRef.close(obj);
    //this.dialogRef.close(this.addUpdateParticipantList);
   // this.dialogRef.close('Added');
    this.dialogRef.close();
  }


}
